import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["overlay", "panel", "toggle", "closeButton"]

  connect() {
    this.isOpen = false
    this.onResize = this.handleResize.bind(this)
    this.onKeydown = this.handleKeydown.bind(this)

    window.addEventListener("resize", this.onResize)
    this.syncState()
  }

  disconnect() {
    window.removeEventListener("resize", this.onResize)
    document.removeEventListener("keydown", this.onKeydown)
    document.body.classList.remove("overflow-hidden")
  }

  open(event) {
    if (event) event.preventDefault()
    if (!this.isMobileViewport) return

    this.isOpen = true
    this.syncState()
    this.closeButtonTarget?.focus()
  }

  close(event) {
    if (event) event.preventDefault()

    this.isOpen = false
    this.syncState()
    this.toggleTarget?.focus()
  }

  handleResize() {
    if (!this.isMobileViewport) {
      this.isOpen = false
    }

    this.syncState()
  }

  handleKeydown(event) {
    if (event.key === "Escape") {
      this.close()
    }
  }

  syncState() {
    const mobileOpen = this.isMobileViewport && this.isOpen

    this.overlayTarget.classList.toggle("hidden", !mobileOpen)
    this.panelTarget.classList.toggle("-translate-x-full", this.isMobileViewport && !mobileOpen)

    if (this.hasToggleTarget) {
      this.toggleTarget.setAttribute("aria-expanded", mobileOpen ? "true" : "false")
    }

    if (mobileOpen) {
      document.body.classList.add("overflow-hidden")
      document.addEventListener("keydown", this.onKeydown)
    } else {
      document.body.classList.remove("overflow-hidden")
      document.removeEventListener("keydown", this.onKeydown)
    }
  }

  get isMobileViewport() {
    return window.matchMedia("(max-width: 1279px)").matches
  }
}
